import CardSvg from '@/components/ui/svg/CardSvg';

type CardsCellProps = {
    id: string;
};

export const CardsNumberCell = ({ id }: CardsCellProps) => (
    <div className='display-flex align-items-center gap-5'>
        <CardSvg /> {id}{' '}
    </div>
);
